import { render, staticRenderFns } from "./ai-reject-modal.vue?vue&type=template&id=41e8d50e&"
import script from "./ai-reject-modal.vue?vue&type=script&lang=js&"
export * from "./ai-reject-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports